import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useState } from "react";

function useAsyncState(initialValue) {
  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var setter = function setter(x) {
    return new Promise(function (resolve) {
      setValue(x);
      resolve(x);
    });
  };

  return [value, setter];
}

export { useAsyncState };